
          import "TextArea_13vf1nl.linaria.css";
          import { styled } from "@linaria/react";
import React from "react";
import Input from "./Base";
const staticLabelStyles = `
  top: -30px;
  color: var(--cvna-color-blue-6);
  font-size: 14px;
`;
export const TextAreaInput = /*#__PURE__*/styled("textarea")({
  name: "TextAreaInput",
  class: "t1ezxdw6"
});

const TextArea = props => /* @__PURE__ */React.createElement(Input, {
  InputComponent: TextAreaInput,
  ...props
});

export default TextArea;
          